import { service } from '@/request/server'

// 留言列表
export const msgList = (params) => (
  service({
    url: '/leave_a_message/msgList',
    method: 'POST',
    data: params
  })
)

// 置顶留言
export const msgTop = (params) => (
  service({
    url: '/leave_a_message/top',
    method: 'GET',
    params
  })
)

// 删除留言
export const msgDel = (params) => (
  service({
    url: '/leave_a_message/delMsg',
    method: 'GET',
    params
  })
)

// 操作留言状态
export const changeStatus = (params) => (
  service({
    url: '/leave_a_message/changeStatus',
    method: 'GET',
    params
  })
)
